import { render, staticRenderFns } from "./PopupPromptAlert.vue?vue&type=template&id=10e5fc90&scoped=true&"
import script from "./PopupPromptAlert.vue?vue&type=script&lang=js&"
export * from "./PopupPromptAlert.vue?vue&type=script&lang=js&"
import style0 from "./PopupPromptAlert.vue?vue&type=style&index=0&id=10e5fc90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e5fc90",
  null
  
)

export default component.exports